import { useLayoutEffect } from 'react';

const useNoop = () => undefined;

export const useClientLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useNoop;
